import React from 'react';
import { useTranslation } from 'react-i18next';
import { TypeOffre } from '../../../hooks';
import { Typography, Variant } from '../../../styles';

interface TitreCalculTauxProps {
    cssClasse: string;
}

export const TitreCalculTaux: React.FC<TitreCalculTauxProps> = ({
    cssClasse
}) => {
    const [t] = useTranslation(['DetailsOffreModal']);

    return (
        <Typography className={cssClasse} variant={Variant.h3}>
            {t('titreSectionCaculTauxPersonnalise')}
        </Typography>
    );
};

interface TextCalculTauxProps {
    typeOffre: TypeOffre;
}

export const TextCalculTaux: React.FC<TextCalculTauxProps> = ({
    typeOffre
}) => {
    const [t] = useTranslation(['DetailsOffreModal']);

    switch (typeOffre) {
        case TypeOffre.CINQ_ANS_VARIABLE_REDUIT:
            return (
                <>
                    <Typography variant={Variant.p}>
                        {t('calculEcartGarantiApplique')}
                    </Typography>
                    <Typography variant={Variant.p}>
                        {t('calculTauxPreferentielDesjardinsVarier')}
                    </Typography>
                </>
            );
        case TypeOffre.CINQ_ANS_VARIABLE_PROTEGE:
            return (
                <>
                    <Typography variant={Variant.p}>
                        {t('calculEcartGarantiApplique')}
                    </Typography>
                    <Typography variant={Variant.p}>
                        {t('calculTauxPreferentielDesjardinsProtege')}
                    </Typography>
                </>
            );
        case TypeOffre.CINQ_ANS_REVISABLE_FERME:
            return (
                <>
                    <Typography variant={Variant.p}>
                        {t('calculEcartGarantiApplique1An')}
                    </Typography>
                    <Typography variant={Variant.p}>
                        {t('calculTauxReviseUneFoisParAn')}
                    </Typography>
                </>
            );
        default:
            return <></>;
    }
};
